import { $api } from "@/shared/api";

// Код приглашения игрока (`GET /api/referrals/me`, первый запрос его создаёт) и сколько
// друзей пришло по ссылке. Код не меняется — перечитывать незачем.
export const useReferral = () =>
  $api.useQuery("get", "/api/referrals/me", undefined, { staleTime: Infinity });
